import { Component, OnInit } from "@angular/core"

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { Deposit, DepositService } from "src/app/services/deposit.service"
import { LocaleConverterService } from "src/app/common/helpers/locale-converter.service";
import { SetTitleService } from "src/app/services/set-title.service";

@Component({
  templateUrl: "./deposit.component.html",
  styleUrls: ["./deposit.component.css"]
})

export class DepositComponent implements OnInit {
  deposits: Deposit[] = []
  openingDepositIndexes: number[] = []
  loading: boolean = false

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private depositService: DepositService,
    private converter: LocaleConverterService,
    private settitleservice : SetTitleService
  ) {}

  ngOnInit() {
    this.getDeposits();
    this.settitleservice.sendTitle("Deposits");
  }

  async getDeposits() {
    if (!this.session.isLoggedIn()) return
    
    this.loading = true
    await this.depositService.getDeposits()
    this.loading = false

    this.depositService.deposits.subscribe(data => this.deposits = data)
  }

  toggleDeposit(index: number) {
    console.log({index})
    if (this.isOpen(index)) {
      this.openingDepositIndexes = this.openingDepositIndexes.filter(number => number !== index)
      return
    }

    this.openingDepositIndexes = this.openingDepositIndexes.concat(index)
  }

  isOpen(index: number) {
    return this.openingDepositIndexes.includes(index)
  }
}